import styled from 'styled-components';

export const SelectItem = styled.img`
    margin-right: 4px;
    cursor: pointer;
`
